export default __webpack_public_path__ + "static/media/line_for_brief_section[1].e8c3add2.svg";